// 9fbef606107a605d69c0edbcd8029e5d
import logger from '@tcp/core/src/utils/loggerInstance';
import { call, put, takeLatest, select } from 'redux-saga/effects';
import Abstractor from '@tcp/core/src/services/abstractors/common/sizeChartGuide';
import {
  FETCH_DEPARTMENTS_REQUEST,
  FETCH_CATEGORIES_REQUEST,
  fetchDepartmentsSuccess,
  fetchDepartmentsFailure,
  fetchCategoriesSuccess,
  fetchCategoriesFailure,
} from './DynamicSizeChart.actions';

const REFRESH_THRESHOLD = 1 * 60 * 1000; // 1 minute in milliseconds

// Selectors to get existing data from Redux
export const getDepartmentsState = (state) => state.DynamicSizeChart.departments;
export const getCategoriesState = (state) => state.DynamicSizeChart.categoryData;

export function* fetchDepartmentsSaga() {
  try {
    const existingDepartments = yield select(getDepartmentsState);
    const currentTime = new Date().getTime();

    if (
      existingDepartments?.data?.length &&
      existingDepartments?.timestamp &&
      currentTime - existingDepartments.timestamp < REFRESH_THRESHOLD
    ) {
      return;
    }

    const newDepartments = yield call(Abstractor.getSizeChartGuideData, 'departments');
    yield put(fetchDepartmentsSuccess(newDepartments));
  } catch (error) {
    logger.error('Error fetching departments:', error);
    yield put(fetchDepartmentsFailure(error));
  }
}

export function* fetchCategoriesByDepartmentSaga(action) {
  const { payload: departmentId } = action;
  try {
    const existingCategories = yield select(getCategoriesState);
    const currentTime = new Date().getTime();

    if (
      existingCategories?.[departmentId] &&
      existingCategories?.[departmentId].timestamp &&
      currentTime - existingCategories[departmentId].timestamp < REFRESH_THRESHOLD
    ) {
      return;
    }

    const newCategories = yield call(Abstractor.getSizeChartGuideData, departmentId);
    yield put(fetchCategoriesSuccess({ departmentId, categories: newCategories }));
  } catch (error) {
    logger.error('Error fetching categories:', error);
    yield put(fetchCategoriesFailure(error));
  }
}

function* DynamicSizeChartSaga() {
  yield takeLatest(FETCH_DEPARTMENTS_REQUEST, fetchDepartmentsSaga);
  yield takeLatest(FETCH_CATEGORIES_REQUEST, fetchCategoriesByDepartmentSaga);
}

export default DynamicSizeChartSaga;
